/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card, Image, Popover, Tag } from "antd";
import { useState } from "react";
import PopOverCard from "./PopOverCard";

function TaskCard(props: any) {
  const { task, index, totalLength, selectedDate } = props;
  const [open, setOpen] = useState(false);
  const [button1, setButton1] = useState(false);
  const [button2, setButton2] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: task.id,
    data: {
      type: "Task",
      task,
    },
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  if (isDragging) {
    return (
      <div
        className="role_wrapper is_dragging"
        ref={setNodeRef}
        style={style}
      />
    );
  }
  const isLastIndex = index === totalLength - 1;

  console.log("task", task);

  let cardClass = "crewListCard";
  if (task?.status === "completed" || (button1 && button2)) {
    cardClass += " completed";
  } else if (task?.status === "confirmation_pending") {
    cardClass += " confirmation_pending";
  } else if (task?.status === "in_progress") {
    cardClass += " in_progress";
  } else if (task?.status === "scheduled") {
    cardClass += " scheduled";
  }
  const isToday = selectedDate
    ? new Date(selectedDate).toDateString() === new Date().toDateString()
    : false;
  return (
    <div ref={setNodeRef} style={style} className="role_wrapper">
      {index === 0 || isLastIndex ? (
        <Card
          className={
            isLastIndex && isToday
              ? "crewListCard scheduled"
              : `crewListCard ${cardClass}`
          }
          {...listeners}
          {...attributes}
        >
          <div className="taskTitle">
            {index === 0 && (
              <Image src="/images/schedule/icon-home.svg" preview={false} />
            )}
            {isLastIndex && (
              <Image
                src="/images/schedule/icon-crew-yard.svg"
                preview={false}
              />
            )}{" "}
            <span>{task?.title}</span>
          </div>
          <Tag>
            <Image src="/images/schedule/clock-icon.svg" preview={false} />
            {task?.durationMinutes}m
          </Tag>
        </Card>
      ) : (
        <Popover
          title={
            <PopOverCard
              visitData={task}
              setButton1={setButton1}
              setButton2={setButton2}
              button1={button1}
              button2={button2}
            />
          }
          trigger="click"
          open={open}
          onOpenChange={handleOpenChange}
          placement="right"
          arrow={false}
        >
          <Card className={cardClass} {...listeners} {...attributes}>
            <div className="taskTitle">
              <span>{task?.title}</span>
            </div>
            <Tag>
              <Image src="/images/schedule/clock-icon.svg" preview={false} />
              {task?.durationMinutes}m
            </Tag>
          </Card>
        </Popover>
      )}

      {/* <button onClick={() => deleteTask(task.id)}>Delete</button> */}
    </div>
  );
}

export default TaskCard;
